import {
  get_site_config,
  build_value_proposition_block,
  build_info_banner_block,
  build_point_list_block,
} from "./utilities";

export const hotels_sections = (config = {}) => {
  const { brand, payoff } = get_site_config(config);

  return [
    build_info_banner_block({
      title: "Disponibilità in tempo reale e offerte esclusive per te!",
      description:
        "Troverai migliaia di hotel, b&b e appartamenti in tutto il mondo: potrai prenotare in pochi click, usando i tuoi punti, e accedere a sconti e offerte esclusive.",
    }),
    build_value_proposition_block([
      {
        vp_image: "assets/images/liveeps/statics/iStock-1208856002.jpg",
        vp_content: [
          {
            vp_icon: "symbol_lb",
            vp_title: "Assistenza a 360 gradi",
            vp_text:
              "Hai bisogno di informazioni per utilizzare il meglio i tuoi punti? Il nostro customer care è qui per te a darti l'assistenza che hai bisogno.",
          },
          {
            vp_icon: "symbol_lb",
            vp_title: "Su di noi puoi contare!",
            vp_text: `Solo ${brand} ${payoff} ti offre un'assistenza multicanale, telefonica, webchat, WhatsApp, email, webcall a portata di click.`,
          },
        ],
      },
    ]),
    build_point_list_block([
      {
        pl_icon: "shield",
        pl_title: "Un mondo di viaggi",
        pl_text:
          "Straordinari contenuti per te grazie alla nostra partnership con il leader globale del travel online Expedia",
      },
      {
        pl_icon: "happy_pin",
        pl_title: "Per la tua community di viaggiatori",
        pl_text: "400.000 viaggiatori scelgono ogni anno le nostre piattaforme",
      },
      {
        pl_icon: "hands",
        pl_title: "La nostra assistenza",
        pl_text:
          "Un team di assistenza italiano con esperienza pluriennale di supporto",
      },
    ]),
  ];
};
